import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { Branding } from 'src/app/views/components/Branding';
import { BrandingAlert } from 'src/app/views/components/BrandingAlert';
import type { AdProduct } from 'src/graphql/generated';
import type AppState from 'src/types/appState';

export const BrandingEditView = (props: {
  customFeatures?: AdProduct['features'] | undefined;
}) => {
  const { isConfidential } = useSelector(
    (state: AppState) => ({
      isConfidential: state.formData.isConfidential,
    }),
    shallowEqual,
  );

  return (
    <>
      {isConfidential ? (
        <BrandingAlert />
      ) : (
        <Branding customFeatures={props.customFeatures} />
      )}
    </>
  );
};
